// "use client";

import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
} from "@repo/ui";
import { ArrowNarrowRightIcon } from "@spoctech/icons";
import moment from "moment";
import Image from "next/image";
import Link from "next/link";

type NewsMediaCardProps = {
  headline: string;
  mediaUrl: string;
  readingTime: string;
  logo: string;
  description: string;
  publishAt: string;
};

const NewsMediaCard = (props: NewsMediaCardProps) => {
  const { mediaUrl, readingTime, logo, description, publishAt, headline } =
    props;
  const publishAtDate = moment(publishAt).format("DD MMM YYYY");
  return (
    <Link href={mediaUrl} target="_blank" rel="nofollow">
      <Card className="h-full flex flex-col hover:shadow-xl transition-all ease-in-out duration-300">
        <CardHeader className="flex justify-between relative">
          <Image
            src={logo}
            width={100}
            height={100}
            alt={headline}
            className="max-h-7 w-auto object-contain object-left"
          />
          <ArrowNarrowRightIcon className="text-primary-light" />
        </CardHeader>
        <CardContent className="flex-1">
          <Typography
            variant="subtitle1"
            render={<div />}
            className="line-clamp-2 !font-semi-bold mb-4"
          >
            {headline}
          </Typography>
          <Typography className="line-clamp-3 text-gray-700">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <ul className="flex gap-4 items-center justify-between text-gray-500 text-sm">
            <li>
              <b>Publish on</b> {publishAtDate}
            </li>

            <li>{readingTime}. read</li>
          </ul>
        </CardActions>
      </Card>
    </Link>
  );
};

export default NewsMediaCard;
